import { _t } from '../lib/i18n';
import { platformLandingUrl } from '../lib/platformLanding';
import type { Language } from '../types';

type PublicShowcaseClosedPageProps = {
  lang: Language;
};

/** Placeholder until the closed-showcase page gets its own design. */
export default function PublicShowcaseClosedPage({ lang }: PublicShowcaseClosedPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 px-6 text-center text-[var(--text-primary)]">
      <p className="text-3xl font-semibold tracking-wide">{_t('showcase.closedCode', lang)}</p>
      <p className="max-w-md text-sm text-[var(--text-secondary)]">{_t('showcase.closedBody', lang)}</p>
      <a
        href={platformLandingUrl()}
        className="mt-2 text-sm underline decoration-[var(--accent-primary)] underline-offset-4"
      >
        {_t('showcase.closedHome', lang)}
      </a>
    </div>
  );
}
